import { useMemo } from "react";

export const useSignInFormUI = (small?: boolean, buttonLabel?: string) => {
  const buttonName = useMemo(
    () => buttonLabel ?? (small ? "Subscribe" : "Sign up"),
    [small, buttonLabel]
  );

  const inputSize = useMemo(
    () => (small ? ("small" as const) : ("medium" as const)),
    [small]
  );

  const inputSlotProps = useMemo(
    () =>
      small
        ? {
            input: {
              style: { fontSize: 12 },
            },
            inputLabel: {
              style: { fontSize: 14 },
            },
          }
        : {},
    [small]
  );

  const inputLabel = useMemo(
    () => (small ? "Enter your email" : "Email"),
    [small]
  );

  return {
    buttonName,
    inputSize,
    inputSlotProps,
    inputLabel,
  };
};
